import { createFileRoute, redirect } from '@tanstack/react-router';
import { HolidayManagement } from '../components/HolidayManagement';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/holidays')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }
  },
  component: HolidaySettingsComponent,
});

function HolidaySettingsComponent() {
  return <HolidayManagement />;
}
